// extracted by mini-css-extract-plugin
export default {"root":"SectionedFormEdit_root__sQ7z9"};